import { useControlledValue } from "../helpers/useControlledValue.js";
/**
 * Hook to manage multiple-date selection in the DayPicker component.
 *
 * @template T - The type of DayPicker props.
 * @param props - The DayPicker props.
 * @param dateLib - The date utility library instance.
 * @returns An object containing the selected dates, a function to select dates,
 *   and a function to check if a date is selected.
 */
export function useMulti(props, dateLib) {
  const {
    selected: initiallySelected,
    required,
    onSelect
  } = props;
  const [internallySelected, setSelected] = useControlledValue(initiallySelected, onSelect ? initiallySelected : undefined);
  const selected = !onSelect ? internallySelected : initiallySelected;
  const {
    isSameDay
  } = dateLib;
  const isSelected = date => {
    var _selected$some;
    return (_selected$some = selected === null || selected === void 0 ? void 0 : selected.some(d => isSameDay(d, date))) !== null && _selected$some !== void 0 ? _selected$some : false;
  };
  const {
    min,
    max
  } = props;
  const select = (triggerDate, modifiers, e) => {
    let newDates = [...(selected !== null && selected !== void 0 ? selected : [])];
    if (isSelected(triggerDate)) {
      if ((selected === null || selected === void 0 ? void 0 : selected.length) === min) {
        // Min value reached, do nothing
        return;
      }
      if (required && (selected === null || selected === void 0 ? void 0 : selected.length) === 1) {
        // Required value already selected do nothing
        return;
      }
      newDates = selected === null || selected === void 0 ? void 0 : selected.filter(d => !isSameDay(d, triggerDate));
    } else {
      if ((selected === null || selected === void 0 ? void 0 : selected.length) === max) {
        // Max value reached, reset the selection to date
        newDates = [triggerDate];
      } else {
        // Add the date to the selection
        newDates = [...newDates, triggerDate];
      }
    }
    if (!onSelect) {
      setSelected(newDates);
    }
    onSelect === null || onSelect === void 0 || onSelect(newDates, triggerDate, modifiers, e);
    return newDates;
  };
  return {
    selected,
    select,
    isSelected
  };
}